import AxiosService from "axios"
import axios, { INIT_HEADERS } from "../../../api/axios-service"
import jwtDefaultConfig from "./jwtDefaultConfig"

export default class JwtService {
  // ** jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // ** For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // ** For Refreshing Token
  subscribers = []

  constructor(jwtOverrideConfig) {
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // ** Request Interceptor
    // axios.interceptors.request.use(
    //   (config) => {
    //     // ** Get token from localStorage
    //     const accessToken = this.getToken()

    //     // ** If token is present add it to request's Authorization Header
    //     if (accessToken) {
    //       // ** eslint-disable-next-line no-param-reassign
    //       config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
    //     }
    //     return config
    //   },
    //   (error) => Promise.reject(error)
    // )

    // ** Add request/response interceptor
    axios.interceptors.response.use(
      (response) => {

        if (response.request.responseURL.includes('/Account/Login')) {
          window.location.href = '/login'
          localStorage.removeItem('userData')
          // remove all cookies
          const cookies = document.cookie.split(';')
          for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i]
            const eqPos = cookie.indexOf('=')
            const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`
          }
          
        }

        return response
      },
      (error) => {
        // ** const { config, response: { status } } = error
        const { config, response } = error
        let originalRequest = config


        // ** if (status === 401) {
        if (response && response.status === 401 && !config.url.includes('Logout')) {
          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.refreshToken().then((r) => {
              this.isAlreadyFetchingAccessToken = false

              // ** Update accessToken in localStorage
              this.setToken(r.data.token)
              this.setRefreshToken(r.data.refreshToken)

              this.onAccessTokenFetched(r.data.token)
            })
          }
          const retryOriginalRequest = new Promise((resolve) => {
            this.addSubscriber((accessToken) => {
              // ** Make sure to assign accessToken according to your response.
              // ** Check: https://cardifyco.ticksy.com/ticket/2413870
              // ** Change Authorization header

              // if (!originalRequest.headers) {
              originalRequest = {
                ...originalRequest,
                headers: {
                  ...INIT_HEADERS,
                  Authorization: `${this.jwtConfig.tokenType} ${accessToken}`
                }
              }
              // } else {
              //   originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
              // }

              resolve(axios(originalRequest))
            })
          })
          return retryOriginalRequest
        }
        return Promise.reject(error)
      }
    )
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter((callback) => callback(accessToken)
    )
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return JSON.parse(localStorage.getItem(this.jwtConfig.storageTokenKeyName))
  }

  getRefreshToken() {
    return JSON.parse(localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName))
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, JSON.stringify(value))
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, JSON.stringify(value))
  }

  login(args) {
    return axios.post(this.jwtConfig.loginEndpoint, args, {
      headers: {
        __tenant: args.tenant
      }
    })
  }

  register(...args) {
    return axios.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return AxiosService.post(`${this.jwtConfig.refreshEndpoint}/${this.getRefreshToken()}`)
  }

  post(url, data = null, config = null) {
    if (config) {
      return axios.post(url, data, config)
    }
    return axios.post(url, data)
  }

  put(url, data = null, config = null) {
    if (config) {
      return axios.put(url, data, config)
    }
    return axios.put(url, data)
  }

  get(url, config = null) {
    if (config) {
      return axios.get(url, config)
    }
    return axios.get(url)
  }

  delete(url, config = null) {
    if (config) {
      return axios.delete(url, config)
    }
    return axios.delete(url)
  }

}
